import { defineStore } from 'pinia'
import theme from '@/helpers/defaultTheme.js'
import { getSnackbar, shadeColorByPercent } from '@/helpers/helpers'
import cloneDeep from 'lodash.clonedeep'
import pinia from '@/store.js'

const defaultState = {
  loading: false,
  selectedProcessStepName: null,
  availableUpdate: false,
  redirectUrl: null,
  spinnerUrl: null,
  announcements: [],
  theme: cloneDeep(theme.LIGHT),
  snack: {
    show: false
  }
}

export const useAppStore = defineStore('app', {
  state: () => JSON.parse(localStorage.getItem('app')) ?? { ...defaultState },
  getters: {},
  actions: {
    setPrimaryBaseColor(color) {
      // //vuetify's color generator does weird stuff. like if maroon is the base color then lighten-5 is orange. but this code seems to make appropriate colors.
      // //if adding a new color here like `lighten2` ensure you also add it in the defaultTheme.js
      if (color && color !== '') {
        this.theme.colors.primary = color
        this.theme.colors['primary-lighten-3'] = shadeColorByPercent(color, 0.3)
        this.theme.colors['primary-lighten-5'] = shadeColorByPercent(color, 0.5)
        this.theme.colors['primary-lighten-9'] = shadeColorByPercent(color, 0.9)
      } else {
        //vuex has issues if you try and set state.theme.primary = theme.LIGHT.primary (i tried using Vue.set and state.theme = { ...state.theme, primaryBlah }
        this.theme.colors.primary = theme.LIGHT.colors.primary
        this.theme.colors['primary-lighten-3'] =
          theme.LIGHT.colors['primary-lighten-3']
        this.theme.colors['primary-lighten-5'] =
          theme.LIGHT.colors['primary-lighten-5']
        this.theme.colors['primary-lighten-9'] =
          theme.LIGHT.colors['primary-lighten-9']
      }
    },
    setBannerColor(color) {
      this.theme.colors.banner =
        color && color !== '' ? color : theme.LIGHT.colors.banner
    },
    showSnack(type, msg, displayAsHtml = false) {
      const snack = getSnackbar(type, msg, displayAsHtml)
      this.snack = { ...snack, show: true }
    }
  }
})

useAppStore(pinia).$subscribe((mutation, state) => {
  localStorage.setItem('app', JSON.stringify(state))
})
